import React from 'react';
import styles from './FormFields.module.css';

// Reusable InputField for player modal
export const InputField = ({ label, name, value, onChange, isEditMode, Icon, required, error, isAdding }) => (
  <div className={styles.fieldContainer}>
    <label className={styles.fieldLabel}> 
      {Icon && <Icon className={styles.fieldIcon}/>} {label} {isAdding ? (required ? (<span style={{color:"red", marginLeft:"5px"}}>*</span>) : (<span style={{marginLeft:"5px", fontSize:"13px", color:"gray"}}>(optional)</span>)): ("")}
    </label>
    {isEditMode ? (
      <input 
        className={`${styles.inputField} ${error ? styles.inputError : ""}`}
        type="text" 
        name={name} 
        value={value || ""} 
        onChange={onChange} 
        required={required}
      />
    ) : (
      <p className={styles.fieldInformation}> {value || "—"} </p>
    )}
  </div>
);


// Reusable SelectField for player modal
export const SelectField = ({ label, name, optionId, optionName, value, onChange, options, isEditMode, display, Icon, required, error, isAdding }) => (
  <div className={styles.fieldContainer}>
    <label className={styles.fieldLabel}> 
      {Icon && <Icon className={styles.fieldIcon}/>} {label} {isAdding ? (required ? <span style={{color:"red", marginLeft:"5px"}}>*</span> : <span style={{marginLeft:"5px", fontSize:"13px", color:"gray"}}> (optional)</span>) : ("")} 
    </label>
    {isEditMode ? (
      <select 
        className={`${styles.selectField} ${error ? styles.inputError : ""}`}
        name={name} 
        value={value || ""} 
        onChange={onChange}
        required={required}
      >
        <option value="">Select {label}</option>
        {options.map((opt) => (
          <option key={opt[optionId]} value={opt[optionId]}>
            {opt[optionName]}
          </option>
        ))}
      </select>
  ) : (
    <p className={styles.fieldInformation}> {display || '—'} </p>
  )}
  </div>
);